import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useFieldAttributes } from "../../../services/field-attributes.js";
import { getDateTimePartsErrors } from "../../../ui/date-time-field/date-time-field-utils.js";
import { DateTimeFieldWUT } from "../../../ui/date-time-field/date-time-field-wut.js";
import { FieldDescriptionWUT } from "../../../ui/field-description/field-description-wut.js";
import { FieldErrorWUT } from "../../../ui/field-error/field-error-wut.js";
import { FieldLabelWUT } from "../../../ui/field-label/field-label-wut.js";
import { Widget } from "../../../ui/widget/widget.js";
const DateTimeInputWUT = ({
  id,
  description,
  target,
  value,
  error,
  hasError = false,
  errorMessage,
  required,
  label,
  hideLabel,
  FieldLayout,
  use24HourFormat,
  disabled,
  hidePlaceholder,
  showDateLabels,
  requiredIndicatorType,
  requiredIndicatorPlacement,
  onBlur,
  onFocus,
  onChange,
  widgetHtml,
  widgetEnabled
}) => {
  const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
  return /* @__PURE__ */ jsx(
    FieldLayout,
    {
      fieldId: id,
      renderLabel: () => /* @__PURE__ */ jsx(
        FieldLabelWUT,
        {
          labelId,
          required,
          label,
          hideLabel,
          requiredIndicatorType,
          requiredIndicatorPlacement
        }
      ),
      renderInput: () => widgetHtml && widgetEnabled ? /* @__PURE__ */ jsx(
        Widget,
        {
          fieldId: id,
          widgetHtml,
          onChange,
          value
        }
      ) : /* @__PURE__ */ jsx(
        DateTimeFieldWUT,
        {
          use24HourFormat,
          onBlur,
          onChange,
          onFocus,
          value: value ?? "",
          id,
          disabled,
          hidePlaceholder,
          showDateLabels,
          required,
          errors: getDateTimePartsErrors(hasError, value ?? ""),
          inputId,
          ariaLabelledBy: labelId,
          ariaDescribedBy
        }
      ),
      renderDescription: () => /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          FieldErrorWUT,
          {
            target,
            hasError,
            errorMessage,
            id: errorId
          }
        ),
        /* @__PURE__ */ jsx(FieldDescriptionWUT, { description, id: descriptionId })
      ] })
    }
  );
};
export {
  DateTimeInputWUT
};
//# sourceMappingURL=date-time-input-wut.js.map
